import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function ReferenceSourcesPanel() {
  const {data,isLoading,error} = useQuery({queryKey:['reference-sources'],queryFn:api.referenceSources,staleTime:60_000});
  const [month,setMonth] = useState('');
  const [search,setSearch] = useState('');
  if (isLoading) return <div className="card p-4">参照データを確認中…</div>;
  if (error || !data) return <div role="alert" className="card p-4 text-red-700">参照データ一覧を取得できませんでした。</div>;
  const months = [...new Set(data.rows.map(r => r.month))].sort().reverse();
  const selected = month || months[0] || '';
  const rows = data.rows.filter(r => (selected === 'all' || r.month === selected) && `${r.dataset} ${r.source} ${r.file ?? ''}`.includes(search.trim()));
  return <section className="card p-4 space-y-4">
    <div>
      <h2 className="text-lg font-semibold">参照データ一覧</h2>
      <p className="text-sm text-slate-600 mt-1">年月ごとに、病院実績ダッシュボードのデータソースを確認できます。</p>
      <p className="text-xs text-slate-500 mt-1">「集計収載」は現在の集計にある月です。「原本確認済」はビルド時に原本を確認した月で、取込・照合の完了を意味しません。</p>
    </div>
    <div className="flex flex-wrap items-end gap-4">
      <label className="text-sm">年月<select aria-label="参照データの年月" value={selected} onChange={e=>setMonth(e.target.value)} className="block border rounded px-3 py-2 mt-1">
        <option value="all">すべての年月</option>{months.map(m=><option key={m} value={m}>{m.replace('-', '年')}月</option>)}
      </select></label>
      <label className="text-sm">データソースを検索<input value={search} onChange={e=>setSearch(e.target.value)} className="block border rounded px-3 py-2 mt-1" placeholder="給与、手術、行為別など" /></label>
      <span className="text-xs text-slate-500 pb-2">{rows.length}件</span>
    </div>
    {data.unavailable.length > 0 && <p className="text-sm text-amber-800 bg-amber-50 rounded p-3">未確認：{data.unavailable.join('、')}</p>}
    <div className="overflow-x-auto">
      <table className="w-full text-sm border-collapse">
        <caption className="sr-only">年月とデータソースの一覧</caption>
        <thead className="bg-slate-100 text-left"><tr>{['年月','データ','データソース','状態','原本・補足'].map(h=><th scope="col" key={h} className="p-3 border-b whitespace-nowrap">{h}</th>)}</tr></thead>
        <tbody>{rows.map((r,i)=><tr key={`${r.month}-${r.dataset}-${i}`} className="border-b align-top hover:bg-slate-50">
          <td className="p-3 whitespace-nowrap">{r.month.replace('-', '年')}月</td><td className="p-3 whitespace-nowrap font-medium">{r.dataset}</td>
          <td className="p-3 min-w-48">{r.source}</td><td className="p-3 whitespace-nowrap">{r.status}</td>
          <td className="p-3 min-w-64"><div className="break-words">{r.file}</div><div className="text-xs text-slate-500 mt-1">{r.note}</div></td>
        </tr>)}</tbody>
      </table>
      {rows.length===0 && <p className="p-6 text-center text-slate-500">該当する参照データはありません。</p>}
    </div>
    <p className="text-xs text-slate-400">確認日時：{new Date(data.checkedAt).toLocaleString('ja-JP')}</p>
  </section>;
}
